import {LangsList} from "migration/entities/base/mlString";
import {SetLangAction, LangActionEnum, SetOtherLangsAction} from "./types";

export const LangActionCreators = {
    setLang: (payload: LangsList): SetLangAction => ({type: LangActionEnum.SET_LANG, payload}),
    setOtherLangs: (payload: LangsList[]): SetOtherLangsAction => ({type: LangActionEnum.SET_OTHER_LANGS, payload}),
}
